import * as React from 'react'
import { Typography } from '@material-ui/core'
import HighlightMatch from '../highlightMatch'
import { isBrandMatch, TheChirpyestMatchType } from '../../types/theChirpyest'

interface MatchedBrandBadgeProps {
  matchType?: TheChirpyestMatchType | null
  matchedBrandName?: string | null
  searchText?: string
  className?: string
}

/** "matched brand: X" indicator for a chirpyest-community search result, shown only when the match came from a brand. */
const MatchedBrandBadge = ({
  matchType,
  matchedBrandName,
  searchText,
  className,
}: MatchedBrandBadgeProps) => {
  if (!isBrandMatch(matchType) || !matchedBrandName) return null

  return (
    <Typography variant="caption" className={className}>
      matched brand:{' '}
      <HighlightMatch text={matchedBrandName} query={searchText} />
    </Typography>
  )
}

export default MatchedBrandBadge
